module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Users_Icon_White.4c57cf44.png";